import DialogPreview from 'components/DialogPreview/DialogPreview'
import { Divider, Grid, TextField, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { Convert, ConvertDateToUnixOrNull, FnAxios, FnDialog, I18n, ParseHtml, undefinedOrNull } from 'utilities/utilities';
import { APIStatusCode, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { BtnBack, BtnExportExcel, BtnSendRequest } from 'components/Button/ButtonAll';
import { FormProvider, useForm } from 'react-hook-form';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { ApiProject } from 'enum/api';
import { useLocation, useNavigate } from 'react-router';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { RadioListItem } from 'components/Input/Radio';
import moment from "moment";
import { TextBoxItem } from 'components/Input/TextBox';
import UploadFileItem from 'components/Input/UploadFile';

const ModalReadyPresent = ({ isOpen, setIsOpen, ObjData }) => { //Pop Up > พร้อมนำเสนอ
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const navigate = useNavigate();

    // const [isBtnSendReadyPresent, setisBtnSendReadyPresent] = useState(false);
    const [lstProjectCheckList, setlstProjectCheckList] = useState([]);
    const [nCheckListFormID, setnCheckListFormID] = useState(0);

    const [loadingTable, setloadingTable] = useState(null);
    const [dataRow, setDataRow] = useState<PaginationInterface>({ ...initRows, });

    const onClearFile = useRef(null);
    const [arrFileDocument, setarrFileDocument] = useState([]);

    const [isPermission, setisPermission] = useState(false);
    const [isEdit, setisEdit] = useState(null);
    const [nProjectID, setnProjectID] = useState(0);

    //ถ้าเร่งด่วนจะให้เลือก คณะกรรมการบริหาร พร้อมกดปุ่มส่ง ส่งพิจารณาข้อเสนอ
    const [isFastTrack, setisFastTrack] = useState(false);
    const [nYear, setnYear] = useState(null); //คณะกรรมการบริหารประจำปี
    const [lstCommitteeRoundUser, setlstCommitteeRoundUser] = useState([]); //ข้อมูลในแต่ล่ะ รอบที่เปิดในปีนั้นๆ    
    const [sMessage, setsMessage] = useState("บันทึก");
    const [isSecretary, setisSecretary] = useState(false);

    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            dOwnerPresentDue: null,
            nCommitteeRoundID: null,
        },
    });

    useEffect(() => {
        if (isOpen && ObjData) {
            setisEdit(ObjData?.isEdit);
            setisPermission(ObjData?.isPermission);
            setnProjectID(ObjData?.nProjectID);
            setisFastTrack(ObjData?.isFastTrack);
            setsMessage(ObjData?.sMessage);
            setisSecretary(ObjData?.isSecretary);
            if (ObjData?.nProjectID !== 0) GetProjectCheckList(ObjData?.nProjectID, ObjData?.isFastTrack, ObjData?.isPermission, ObjData?.isEdit);
        }
    }, [isOpen, ObjData])

    const GetProjectCheckList = async (_nProjectID, _isFastTrack, _isPermission, _isEdit) => {
        DialogFn.BlockUI();
        await AxiosFn.Get(ApiProject.GetProjectCheckList, { nProjectID: _nProjectID, isFastTrack: _isFastTrack, }, (result) => {
            form.setValue("dOwnerPresentDue", (_isPermission === false && _isEdit === false) ? result.nDateOwnerPresentDue ? moment(result.nDateOwnerPresentDue) : null : null); //ความคิดเห็น nDateOwnerPresentDue | nDateOwnerReturnDue           
            if (_isFastTrack) //ถ้าเร่งด่วนจะให้เลือก คณะกรรมการบริหาร พร้อมกดปุ่มส่ง ส่งพิจารณาข้อเสนอ
            {
                setnYear(result.nYear);//คณะกรรมการบริหารประจำปี
                setlstCommitteeRoundUser(result.lstCommitteeRoundUser); //ข้อมูลในแต่ล่ะ รอบที่เปิดในปีนั้นๆ
            }
            setlstProjectCheckList(result.lstProjectCheckList);
            setnCheckListFormID(result.nCheckListFormID);
            setarrFileDocument(result.lstFileDocument);
            setDataRow({
                ...initRows,
                arrRows: result.lstProjectCheckList ?? [],
                nDataLength: (result.lstProjectCheckList || []).length,
            });
            DialogFn.UnBlockUI();
        });
    }

    const handleClose = () => {
        setIsOpen(false);
        form.reset();
    }

    const arrDataColumn = [
        {
            field: "sCheckList",
            headerName: `${I18n.SetText("Project.sTitleName")}`,
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 3,
        },
        {
            field: "sNote",
            headerName: `${I18n.SetText("Project.sIssue")}`,
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: isEdit === false ? 5 : 3,
            renderCell: (item) => {
                return (
                    ((isEdit === false && isPermission) ?
                        <Grid item xs={12} md={12}>
                            <TextBoxItem
                                id={"sNote_" + item.row.sID}
                                name={"sNote_" + item.row.sID}
                                maxLength={500}
                                label=""
                                disabled={!isPermission}
                                required={false}
                                defaultValue={item.row.sNote}
                                onChange={(e) => {
                                    item.row.sNote = e.target.value;
                                }}
                            />
                        </Grid>
                        :
                        <Typography>{ParseHtml(item.row.sNote)}</Typography>
                    )
                );
            }
        },
    ];

    const [dataColumn, setdataColumn] = useState([]);

    useEffect(() => {
        let _arrDataColumn = arrDataColumn ?? [];
        if (isEdit === true || !isPermission) //ส่งกลับแก้ไข || ความคิดเห็น 
        {
            let _dataColumn = _arrDataColumn ?? [];
            _dataColumn.push(
                {
                    field: "sRejectComment",
                    headerName: (isEdit === true ? `${I18n.SetText("Project.sReject")}` : "เหตุผลในการส่งกลับแก้ไข"),
                    headerAlign: "center",
                    align: "left",
                    sortable: false,
                    flex: 4,
                    renderCell: (item) => {
                        if (!isPermission) {
                            return (<Typography>{ParseHtml(item.row.sRejectComment)}</Typography>); //ความคิดเห็น                             
                        } else {
                            return (
                                <Grid item xs={12} md={12}>
                                    <TextBoxItem
                                        id={"sRejectComment_" + item.row.sID}
                                        name={"sRejectComment_" + item.row.sID}
                                        maxLength={500}
                                        label=""
                                        disabled={!isPermission}
                                        required={false}
                                        onChange={(e) => {
                                            item.row.sRejectComment = e.target.value;
                                        }}
                                    />
                                </Grid>
                            );
                        }
                    }
                },
            )
            setdataColumn([..._dataColumn]);
        } else {
            setdataColumn(_arrDataColumn);
        }
    }, [isEdit, isPermission])

    const handleSubmit = (nModeID: EnumSaveModeProject, nStatusID: EnumProjectStatusID) => {
        if (isEdit === true && (dataRow.arrRows || []).length === (dataRow.arrRows || []).filter(f => f.sRejectComment === null).length) return DialogFn.Warning("กรุณากรอกข้อมูลเหตุผลอย่างน้อย 1 หัวข้อ");

        let ObjForm = form.getValues();
        let dOwnerDue = moment(ObjForm.dOwnerPresentDue);
        let nUnixTimeOwnerDue = dOwnerDue.isValid ? ConvertDateToUnixOrNull(dOwnerDue) : 0;

        let ObjParam = {
            sLocation: location.pathname,
            nSaveModeProject: nModeID,
            nStatusID: nStatusID,
            nProjectID: nProjectID,
            nCheckListFormID: nCheckListFormID,
            nOwnerDue: nUnixTimeOwnerDue,
            // nOwnerPresentDue: nUnixTimeOwnerDue,
            // nOwnerReturnDue: nUnixTimeOwnerDue, //Return ตอนส่งกลับแก้ไข
            lstProjectCheckList: dataRow.arrRows ?? [],
            lstFileDocument: arrFileDocument ?? [],
            isEdit: isEdit ?? false, //True โหมดของ Edit คือ ตอนที่ส่งกลับแก้ไข | False โหมดตอน พร้อมส่งนำเสนอ

            isFastTrack: isFastTrack ?? false, //ถ้าเร่งด่วนจะให้เลือก คณะกรรมการบริหาร พร้อมกดปุ่มส่ง ส่งพิจารณาข้อเสนอ
            nCommitteeRoundID: isFastTrack ? Convert.StringToInt(ObjForm.nCommitteeRoundID) : null, //ข้อมูลในแต่ล่ะ รอบที่เปิดในปีนั้นๆ
        };

        // DialogFn.Submit(I18n.SetText(isEdit ? "Message.ConfirmRevisitEdit" : "Message.ConfirmApprove", I18NextNs.labelComponent), () => {
        DialogFn.Submit(("คุณต้องการ" + sMessage + "หรือไม่ ?"), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectCheckList, ObjParam, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success) {
                    // DialogFn.Success(I18n.SetText(isEdit ? "Message.SaveRecallComplete" : "Message.SaveApproveComplete", I18NextNs.labelComponent), () => { handleClose(); navigate("/ProjectCheckRecordList")});
                    DialogFn.Success((sMessage + "สำเร็จ"), () => { handleClose(); navigate("/ProjectCheckRecordList") });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            });
        });
    }

    const onExportExcel = () => {
        DialogFn.BlockUI();
        let nYearThai = parseInt(moment().format('YYYY')) + 543;
        let sFileName = `ความคิดเห็น_รายละเอียดในข้อเสนอโครงการ_${moment().format('DMMM')}${nYearThai}.xlsx`;
        let param = {
            nProjectID: nProjectID,
            nPresentTime: moment(form.getValues("dOwnerPresentDue")).valueOf()
        }
        AxiosFn.DowloadFileBlob(ApiProject.ExportProjectExcelReadyPresent, param, sFileName, () => {
            DialogFn.UnBlockUI();
        });
    }

    return (
        <DialogPreview
            IsOpen={isOpen}
            Title={!isPermission ? "ความคิดเห็น" : (isEdit ? "ส่งกลับแก้ไข" : (isFastTrack ? "ส่งพิจารณาข้อเสนอ" : "พร้อมนำเสนอ"))}
            required={false}
            sMaxWidth="lg"
            onClose={handleClose}
            JsxDialogAction
            CloseSave={false}
            Close={false}
            onCustomButton={
                <Grid container spacing={2} justifyContent={"space-between"} style={{ padding: '1%', paddingBottom: '1%' }}>
                    <Grid item>
                        <BtnBack id={"BtnBack_ReadyPresent"} onClick={handleClose} />
                    </Grid>
                    {isPermission &&
                        <Grid item>
                            {/* IsDisabled={!isBtnSendReadyPresent} */}
                            <BtnSendRequest
                                IsDisabled={(isFastTrack === true && lstCommitteeRoundUser.length === 0) ? true : false}
                                id={"BtnSend_ReadyPresent"}
                                txt={isEdit ? "ตกลง" : (isFastTrack ? "ยืนยัน" : "บันทึกพร้อมนำเสนอ")}
                                onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit,
                                    (isEdit ?
                                        EnumProjectStatusID.nStatusID_3
                                        : (isFastTrack ?
                                            EnumProjectStatusID.nStatusID_10
                                            : EnumProjectStatusID.nStatusID_2)
                                    )), (err) => console.log("err", err))} />
                        </Grid>
                    }
                </Grid>
            }
        >
            <Grid container spacing={2} justifyContent={"start"} alignItems={"start"} style={{ padding: '1%', paddingBottom: '1%' }}>
                <FormProvider {...form}>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%' }}>
                        <Grid item xs={12} md={12} container spacing={1}>
                            <Grid item>
                                <Typography style={{ color: "#225192", fontSize: "16px", fontWeight: 400 }}>{isEdit ? "กำหนดวันที่ในการส่งกลับหลังจากการแก้ไขข้อมูล (ภายในวันที่)" : (isFastTrack ? "วันที่นัดในการพิจารณาข้อเสนอ" : "วันที่นัดในการนำเสนอ")}</Typography>
                            </Grid>
                            <Grid item>
                                <Typography style={{ fontSize: "16px", fontWeight: 400 }} color={'red'}>*</Typography>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Divider style={{ color: "#212836" }} />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <DatePickerItem
                                id={'dOwnerPresentDue'}
                                name={'dOwnerPresentDue'}
                                label={"วันที่"}
                                fullWidth={true}
                                required={true}
                                minDate={new Date()}
                                // maxDate={_dEnd}
                                disabled={!isPermission}
                                // defaultCalendarMonth={moment(new Date()).startOf('year').year(new Date().getFullYear())}
                                IsDisablePortal={true}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%' }}>
                        <Grid item xs={12} md={12} container spacing={1}>
                            <Grid item xs={10} container spacing={1}>
                                <Grid item>
                                    <Typography style={{ color: "#225192", fontSize: "16px", fontWeight: 400 }}>{isEdit ? "เหตุผลในการส่งกลับแก้ไข" : (isFastTrack ? "ความคิดเห็น (รายละเอียดในการพิจารณาข้อเสนอโครงการ)" : "ความคิดเห็น (รายละเอียดในข้อเสนอโครงการ)")}</Typography>
                                </Grid>
                                {isEdit &&
                                    <Grid item>
                                        <Typography style={{ fontSize: "16px", fontWeight: 400 }} color={'red'}>*</Typography>
                                    </Grid>
                                }
                            </Grid>
                            <Grid item xs={2}>
                                {(isEdit === false && isPermission === false && isSecretary) &&
                                    <Grid container display={"flex"} justifyContent={"flex-end"} spacing={1}>
                                        <BtnExportExcel id={'btnExportExcel'} onClick={() => { onExportExcel(); }} /> {/* txt={'Export Excel File'}  */}
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Divider style={{ color: "#212836" }} />
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1 }}>
                            <DataGrid
                                sTableID='TB_Project_ReadyPresent'
                                isLoading={loadingTable}
                                columns={dataColumn}
                                rows={dataRow}
                                onLoadData={(e) => { }}
                                isHiddenToolHead={true}
                                isShowCheckBox={false}
                                isHiddenPagination={true}
                            />
                        </Grid>
                    </Grid>

                    {/* คณะกรรมการบริหารประจำปี  : รอบที่ แบบ Radio */}
                    {isFastTrack &&
                        <Grid item xs={12} md={12} container spacing={2}>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item>
                                    <Typography style={{ color: "#225192", fontSize: "16px", fontWeight: 400 }}>{"คณะกรรมการบริหารประจำปี " + (nYear !== null ? (nYear + 543) : "")}</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography style={{ fontSize: "16px", fontWeight: 400 }} color={'red'}>*</Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Divider style={{ color: "#212836" }} />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 1 }}>
                                {lstCommitteeRoundUser.length > 0 ?
                                    <RadioListItem
                                        id={"nCommitteeRoundID"}
                                        name={"nCommitteeRoundID"}
                                        label={"คณะกรรมการบริหารประจำปี " + (nYear !== null ? (nYear + 543) : "")}
                                        IsNotShowLabel={true}
                                        required={isFastTrack}
                                        options={lstCommitteeRoundUser}
                                        row={false}
                                        sx={{
                                            alignItems: 'flex-start',
                                            marginBottom: '5%',
                                        }}
                                    />
                                    :
                                    <Typography style={{ fontSize: "16px", fontWeight: 400 }} color={'red'}>{"กรุณาตรวจสอบ ไม่มีข้อมูลคณะกรรมการบริหารประจำปี " + (nYear !== null ? (nYear + 543) : "")}</Typography>
                                }
                            </Grid>
                        </Grid>
                    }

                    {isEdit &&
                        <Grid item xs={12} md={12}>
                            <UploadFileItem
                                required={false}
                                modeDisplay={"list"}
                                id={"arrFileDocument"}
                                name={"arrFileDocument"}
                                label={"เอกสารแนบอื่นๆ"}
                                arrFile={arrFileDocument}
                                setarrFile={setarrFileDocument}
                                Extension={["pdf", "jpg", "jpeg", "png", "doc", "docx", "rar", "zip"]}
                                IsFolder={false}
                                onClearFile={onClearFile}
                                sFolderTemp="Project"
                                IsMultiple={true}
                                nLimitFile={10}
                                sLimitFile="MB"
                                sPositionText="right"
                                IsCrop={true}
                                cropShape={"retangle"}
                                cropRatio={16 / 9}
                                cropResize={true}
                                cropMovable={true}
                                // isRequiredLimitFile={true}
                                disabled={!isPermission}
                            />
                        </Grid>
                    }
                </FormProvider>
            </Grid>
        </DialogPreview>
    )
}

export default ModalReadyPresent
